export default "__VITE_ASSET__CdXrOZYW__"